module.exports = function(gantt) {
	gantt._is_chart_visible = function () {
		return !!this.config.show_chart;
	};



	gantt._get_links_data = function () {
		return this.$data.linksStore.getVisibleItems();
	};




	gantt.isReadonly = function (item) {
		if (item && item[this.config.editable_property]) {
			return false;
		} else {
			return (item && item[this.config.readonly_property]) || this.config.readonly;
		}
	};

	gantt._get_line = function (step) {
		var steps = {
			"second": 1,
			"minute": 60,
			"hour": 60 * 60,
			"day": 60 * 60 * 24,
			"week": 60 * 60 * 24 * 7,
			"month": 60 * 60 * 24 * 30,
			"quarter": 60 * 60 * 24 * 30 * 3,
			"year": 60 * 60 * 24 * 365
		};
		return steps[step] || steps.hour;
	};

};


//////////////////
// WEBPACK FOOTER
// ./sources/core/tasks.js
// module id = 70
// module chunks = 0